import React from "react";
import { ColumnDef } from "@tanstack/react-table";
import { EmailLogProps } from "modules/email_log/store/actionType";

export const TableColumns: ColumnDef<EmailLogProps>[] = [
  {
    id: "slNo",
    header: "Sl. No",
    cell: ({ row }) => row.index + 1,
  },
  {
    accessorFn: (row) => row.title,
    id: "title",
    header: "Title",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.subject,
    id: "subject",
    header: "Subject",
    cell: (info) => info.getValue(),
  },
    {
    accessorFn: (row) => row.receiver,
    id: "receiver",
    header: "Receiver",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.status,
    id: "status",
    header: "Status",
    cell: (info) => info.getValue(),
  },
];
